import React, {Component} from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorReporting from 'material-ui-error-reporting';

const DoneAll = require('react-icons/lib/md/done-all');
const Error = require('react-icons/lib/md/error');

export default class AnmeldungBestaetigenForm extends Component {
  componentWillMount() {
    const {onComponentWillMount} = this.props;

    onComponentWillMount && onComponentWillMount();
  }

  render() {
    const {
      statusCode,
      error,
      errorText,
      transmitting,
      transmissionStatus
    } = this.props;

    return (
      <div>
        <ErrorReporting
          open={error}
          getMessage={ (props) => `${statusCode}: ${errorText}` }
        />
        <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
        {transmitting && <div>
          <h3>Wir suchen Ihre Anmeldedaten…</h3>
          <CircularProgress/>
          <br/><br/>
          …Bitte haben Sie einen Augenblick Geduld.
        </div>}
        {!transmitting && transmissionStatus === "success" && <div>
          <h3>Anmeldung bestätigt</h3>
          <DoneAll size={60}/>
          <br/><br/>
          Vielen Dank. Sie haben Ihre Anmeldung bestätigt.
          <br/><br/>
          In Kürze erhalten Sie eine Bestätigungsmail mit unserer Bankverbindung.
          Damit ist die Online Anmeldung abgeschlossen.
        </div>
        }
        {!transmitting && transmissionStatus !== "success" && <div>
          <h3>Es ist etwas schief gegangen</h3>
          <Error size={60}/>
          <br/><br/>
          Es tut uns leid. Bitte stellen Sie sicher, dass der Link aus der Bestätigunsmail vollständig in
          die Adresszeile Ihres Browsers kopiert wurde.
          <br/><br/>
          Falls der Link in Ordnung ist antworten Sie bitte auf Ihre Bestätigungsmail von
          anmeldung-jugendprogramm@ratzgiwatz.de.
          Wir melden uns bei Ihnen sobald es uns möglich ist.
        </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/anmeldung-bestaetigen/AnmeldungBestaetigenForm.jsx